<template>
  <v-dialog
    v-if="selected"
    :value="dialog"
    :hide-overlay="!dialog"
    @click:outside.stop="closeDialog(true)"
    @keydown.esc="closeDialog(true)"
    persistent
    max-width="1024px"
    :fullscreen="is_mobile"
    :scrollable="is_mobile"
    overlay-opacity="50"
    overlay-color="#ffffff"
    content-class="default-dialog"
    >
    <v-card class="default-dialog-card">
      <v-card-title class="dialog-title">
        <span class="headline">
          <v-icon class="toolbar-icon">mdi-account</v-icon>
          {{ lang.customers.view.customer }} #{{ selected.id }}
        </span>
        <v-spacer></v-spacer>
        <v-icon class="dialog-close-btn" @click="closeDialog()">mdi-close</v-icon>
      </v-card-title>
      <v-card-text class="pa-2">
        <v-container class="pa-0 py-2">
          <v-row class="pa-0">
            <v-col cols="12" lg="6" md="12" sm="12" xs="12" class="view-info">
              <v-row>
                <v-col cols="6" class="px-1">
                  <v-subheader>{{ lang.customers.datatable.headers.name }}</v-subheader>
                  {{ selected.name }}
                </v-col>
                <v-col cols="6" class="px-1">
                  <v-subheader>{{ lang.customers.datatable.headers.phone }}</v-subheader>
                  {{ selected.phone | phoneMask }}
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="6" class="px-1">
                  <v-subheader>{{ lang.customers.datatable.headers.birth_date }}</v-subheader>
                  {{ formatDateAlt(selected.birth_date, false) }}
                </v-col>
                <v-col cols="6" class="px-1">
                  <v-subheader>{{ lang.customers.datatable.headers.identity }}</v-subheader>
                  {{ selected.identity | cpfMask }}
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="6" class="px-1">
                  <v-subheader>{{ lang.customers.datatable.headers.address }}</v-subheader>
                  <addressCard :addresses="selected.addresses" />
                </v-col>
                <v-col cols="6" class="px-1">
                  <v-subheader>{{ lang.customers.datatable.headers.action }}</v-subheader>
                  <Actions :customer="selected" :hideView="true" @action="scrollHistory()" @edit="edit" />
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" class="historic">
                  <v-subheader>{{ lang.customers.datatable.headers.history }}</v-subheader>
                  <v-container
                    class="overflow-y-auto"
                    v-bar="{ preventParentScroll: true, scrollThrottle: 30 }"
                  >
                    <v-card
                      class="mx-auto historic-inside"
                      tile
                    >
                      <v-list-item
                        v-for="(history, chi) in selected.historic.slice().reverse()"
                        :key="`H-${chi}`"
                        class="history"
                        two-line
                      >
                        <v-list-item-icon class="history-icon">
                          <v-icon :color="getHistory(history.type).color">
                            {{ getHistory(history.type).icon }}
                          </v-icon>
                        </v-list-item-icon>
                        <v-list-item-content class="history-content">
                          <v-list-item-title>{{ getHistory(history.type).title }}</v-list-item-title>
                          <v-list-item-subtitle>
                            {{ history.datetime }}
                            <v-tooltip top>
                              <template v-slot:activator="{ on }">
                                <v-btn small icon v-on="on">
                                  <v-icon small color="grey lighten-1">mdi-information</v-icon>
                                </v-btn>
                              </template>
                              <span>{{ history.by_name }} ({{ history.by_function }})</span>
                            </v-tooltip>
                          </v-list-item-subtitle>
                        </v-list-item-content>
                      </v-list-item>
                    </v-card>
                  </v-container>
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="12" lg="6" md="12" sm="12" xs="12">
              <LastOrders
                :list="selected.last_orders"
              />
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="gray" text @click="closeDialog()">{{ lang.customers.view.close }}</v-btn>
        <v-btn color="blue darken-1" @click="edit()" text>{{ lang.customers.actions.edit }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import Actions from './templates/Actions'
import addressCard from './templates/addresses/Card'
import LastOrders from './templates/LastOrders'

import appdata from '@/mixins/appdata'
import utils from '@/mixins/utils'
import view from '@/mixins/defaults/view'
import customers from './mixins/index'

export default {
  components: { Actions, addressCard, LastOrders },
  mixins: [ appdata, utils, view, customers ]
}
</script>

<style src="@/styles/inner/view.scss" lang="scss"></style>
<style scoped src="./styles/index.css"></style>
